"use client";
import { createContext as t } from "react";
const e = t({});
export {
  e as TextButtonRootContext
};
//# sourceMappingURL=text-button-root.context.js.map
